// import React, { useEffect, useState, useRef } from 'react'
import React, {useEffect, useState, useRef, useCallback} from 'react'
import settings from '../settings'
import Marquee from "react-fast-marquee"


function Ticker({tickerdata}) {
    const [ticker, setTicker] = useState([])
    const [datum, setDatum] = useState('')
    const rev = (new Date()).getTime()

    // const speed = ['xs', 'sm', 'md'].includes(settings.viewSize) ? 75 : 15
    const speed = 15

    useEffect(() => {
        const fetchData = async () => {
            const data = fetch(`https://${location.hostname}/media/volitve/lokalne-20221120/rezultati.json?rev=${rev}`)
            const r = await (await data).json()
            // Add some data here and there
            for (let i = 0; i < r.rez.length; i++) {
                for (let ii = 0; ii < r.rez[i].osebe.length; ii++) {
                    let o = r.rez[i].osebe[ii]
                    o.procent = (o.prc * 100).toFixed(2) + '%'
                    o.procent = o.procent.replace('.', ',')
                }
            }
            setTicker(r.rez)
            setDatum(r.datum)
        }
        fetchData()
    }, [])
    return (
        <a className="volitve_link" href={tickerdata.url}>
            <Marquee pauseOnHover={true} pauseOnClick={true} gradient={false} speed={speed}>
                <span className="item">
                    <b>Osveženo: {datum}</b> &nbsp;
                </span>
                <span className="item">
                    <img className="crest" src="/static/volitve_2022/lokalne/mini_slo.svg" alt="Slovenija"/><b>Vsi rezultati</b>
                </span>
                {ticker.map((item, i) => {
                        return (
                            <span key={i} className="item">
                            <img src={'/static/volitve_2022/lokalne/' + item.slug + '.svg'} alt={item.slug}
                                 className="crest"/>
                            <b className="name">{item.naz}:</b>
                                {item.osebe.map((person, ii) => {
                                    return (
                                        <span className="person" key={'_' + ii}>
                                    <b className="name">{person.naz}</b>
                                    <span className="percent">{person.procent}</span>
                                            {ii < item.osebe.length - 1 &&
                                                <span className="comma">,</span>
                                            }
                                </span>
                                    )
                                })}
                        </span>
                        )
                    }
                )}
            </Marquee>
        </a>
    )
}

/**
 * Experiment
 */
const Element = (props) => {
    const {naz, osebe, slug, special, data} = props;
    if (special==1) return(<span className="item">
            <b>{data}</b> &nbsp;
        </span>
    )
    if (special==2) return(<span className="item">
            <img className="crest" src={data} alt="Slovenija"/><b>Vsi rezultati</b>
        </span>
    )
    return (
        <span key={i} className="item">
            <img src={'/static/volitve_2022/lokalne/' + slug + '.svg'} alt={slug} className="crest"/>
            <b className="name">{naz}:</b>
            {osebe && osebe.map((person, ii) => (
                <span className="person" key={'_' + ii}>
                    <b className="name">{person.naz}</b>
                    <span className="percent">{person.procent}</span>
                    {ii < osebe.length - 1 &&
                        <span className="comma">,</span>
                    }
                </span>
            ))}
        </span>
    )
}

const App = ({tickerdata}) => {
    const [items, setItems] = useState([]);
    const [animationRunning, setAnimationRunning] = useState(false);
    const wrapperRef = useRef();
    const indexRef = useRef();

    const handleRefUpdate = useCallback(node => {
        if (node !== null && items.length > 0) {
            indexRef.current = node.firstChild;
            wrapperRef.current = node;
            document.documentElement.style.setProperty('--animationDistance', `${0 - indexRef.current.offsetWidth}px`);
            document.documentElement.style.setProperty('--animationDuration', `${Math.round(indexRef.current.offsetWidth / 100)}s`);
            wrapperRef.current.classList.add('moving');
        }
    }, [items]);

    const handleLoop = () => {
        wrapperRef.current.classList.remove('moving');
        wrapperRef.current.style.animation = 'none';
        const t = wrapperRef.current.offsetHeight; /* trigger reflow */
        wrapperRef.current.style.animation = null;
        shiftNext([...items]);
    };

    const shiftNext = (copy) => {
        const firstitem = copy.shift();
        copy.splice(copy.length, 0, firstitem);
        setItems(copy);
    };

    const handleAnimationEnd = () => {
        handleLoop();
    }


    const [datum, setDatum] = useState('')
    const rev = (new Date()).getTime()
    useEffect(() => {
        const fetchData = async () => {
            const data = fetch(`https://${location.hostname}/media/volitve/lokalne-20221120/rezultati.json?rev=${rev}`)
            const r = await (await data).json()
            // Add some data here an there
            for (let i = 0; i < r.rez.length; i++) {
                for (let ii = 0; ii < r.rez[i].osebe.length; ii++) {
                    let o = r.rez[i].osebe[ii]
                    o.procent = (o.prc * 100).toFixed(2) + '%'
                    o.procent = o.procent.replace('.', ',')
                }
            }
            setItems([
                {special: 1, data: `Osveženo: ${r.datum}`},
                {special: 2, data: '/static/volitve_2022/lokalne/mini_slo.svg'},
                ...r.rez
            ])
            setDatum(r.datum)
        }
        fetchData()
    }, [])

    return (
        <a className="volitve_link" href={tickerdata.url}>
            <div className="wrapper">
                <div className="inner" ref={handleRefUpdate} onAnimationEnd={handleAnimationEnd}>
                    {items.map((obj, index) => <Element {...obj} key={'x' + index}/>
                    )}
                </div>
            </div>
        </a>
    )
}


export {
    App,
    Ticker
}
export default Ticker
